export default __webpack_public_path__ + "static/media/generateDues.b8d50cac.svg";